import { Path, Svg } from "react-native-svg";
import { getToken } from "@tamagui/core";
import { jsx } from "react/jsx-runtime";
const SvgChevronLeft = ({ size = 24, color = "$contentPrimary", ...inProps }) => {
  const outProps = {};
  if (size && (outProps.width = size, outProps.height = size), color) {
    const colorToken = getToken(color, "color");
    outProps.color = colorToken;
  }
  const props = {
    viewBox: "0 0 24 24",
    ...inProps,
    ...outProps
  };
  return /* @__PURE__ */ jsx(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props, children: /* @__PURE__ */ jsx(
    Path,
    {
      fill: "currentColor",
      d: "m8.725 11.729 7.35 7.35q.374.375.363.887a1.26 1.26 0 0 1-.388.888q-.375.375-.888.375-.512 0-.887-.375l-7.675-7.7q-.3-.3-.45-.675t-.15-.75.15-.75.45-.675l7.7-7.7q.375-.374.875-.363.5.013.875.388t.375.887-.375.888z"
    }
  ) });
};
var ChevronLeft_default = SvgChevronLeft;
export {
  ChevronLeft_default as default
};
